import { Skeleton } from 'antd';
import { Container, ShimmerBoxLeft, ShimmerPlayer, ShimmerRightWidget, ShimmerTitle, Wrapper, ShimmerItem } from './styled';

function Shimmer() {
  return (
    <Wrapper id="livestream-shimmer">
      <Container>
        <div>
          <ShimmerBoxLeft>
            <ShimmerPlayer active />
          </ShimmerBoxLeft>
          <ShimmerBoxLeft style={{ marginTop: '20px' }}>
            <ShimmerItem avatar paragraph={{ rows: 4 }} />
          </ShimmerBoxLeft>
        </div>
        <div>
          <ShimmerRightWidget>
            <ShimmerTitle size="small" />
            <Skeleton.Button size="small" active />
          </ShimmerRightWidget>
          <ShimmerRightWidget>
            <ShimmerItem avatar paragraph={{ rows: 1 }} />
            <ShimmerItem avatar paragraph={{ rows: 1 }} />
            <ShimmerItem avatar paragraph={{ rows: 1 }} />
          </ShimmerRightWidget>
        </div>
      </Container>
    </Wrapper>
  );
}

export default Shimmer;
